<template>
    <v-card variant="tonal" :border="true" class="text-center pa-3 elevation-2" :flat="true" :rounded="true">
        <v-btn color="black"
               :icon="true"
               size="large"
               variant="flat"
               :ripple="false"
               class="non-interactive"
               style="border: 1px solid rgb(var(--v-theme-attribute-points));"
        >
            <v-icon icon="mdi-dna" color="attribute-points" />
        </v-btn>
        <div class="text-h6 mt-2">{{ quantity }}</div>
        <div class="currency-label text-medium-emphasis">Attr Points</div>
    </v-card>
</template>

<script setup>
    defineProps({
        quantity: {
            type: [Number, String],
        },
    });
</script>

<style scoped>
    .non-interactive {
        pointer-events: none;
    }
    .currency-label {
        font-size: 0.65rem;
        overflow-wrap: normal;
        word-break: keep-all;
        white-space: nowrap;
    }
</style>
